import React, { ReactElement } from 'react';

import Link from 'atomic/link/link';

const CompanyRulesBase: React.FC = (): ReactElement => (
    <div className="add-opinion-rules">
        <p>
            <b>
                Ostatnia aktualizacja 22.02.2024r.
            </b>
        </p>
        <p>
            <Link target="_blank" href="https://static.opineo.pl/regulamin/dla-podmiotow-wspolpracujacych-22-02-2024.pdf">
                Regulamin Ramowy Opineo.pl dla Podmiotów Współpracujących (kliknij, aby przejść do dokumentu)
            </Link>
        </p>
    </div>
);

export default CompanyRulesBase;
